import React, { useState } from "react"
import { useTranslation } from "react-i18next"

/**
 * Mavzu almashtirish tugmasi — yoruq / qorong'i.
 *
 * Naqsh ATAYLAB til tanlash bilan bir xil (i18n.js + LanguageDropdown.js):
 * localStorage + Redux'siz. Yangi arxitektura kiritilmaydi.
 *
 * ⚠️ Bayroq `<html>` ga qo'yiladi — `<body>` yoki `#root` ga EMAS.
 *    Chek chop etish himoyasi shunga tayanadi: `react-to-print` yangi iframe
 *    yasaydi va `<html>` atributlarini KO'CHIRMAYDI, ya'ni chekda qorong'i
 *    qoidalar umuman ishlamaydi.
 *
 * ⚠️ Yoruq mavzuda atribut O'CHIRILADI (`data-theme="light"` qo'yilmaydi) —
 *    shunda oq mavzu hozirgisidan matematik jihatdan farq qilmasligi kafolat.
 *
 * Sahifa qayta yuklanmaydi (tildan farqli) — CSS atribut o'zgarishi bilan
 * darhol ishlaydi.
 */
const ThemeToggle = () => {
	const { t } = useTranslation()
	const [theme, setTheme] = useState(
		() => document.documentElement.getAttribute('data-theme') || 'light'
	)

	function toggle() {
		const next = theme === 'dark' ? 'light' : 'dark'
		if (next === 'dark') {
			document.documentElement.setAttribute('data-theme', 'dark')
		} else {
			document.documentElement.removeAttribute('data-theme')
		}
		try { localStorage.setItem('THEME', next) } catch (e) { }
		setTheme(next)
	}

	return (
		<button type="button" className="btn header-item waves-effect"
			onClick={toggle}
			title={theme === 'dark' ? t('light_theme') : t('dark_theme')}>
			<i className={theme === 'dark' ? 'uil-sun' : 'uil-moon'} style={{ fontSize: 20 }} />
		</button>
	)
}

export default ThemeToggle
